import { useTranslation } from 'react-i18next';
import { clsx } from 'clsx';

import { Button } from '@treezor/design-system';

import { IKycStatusHistoryModalProps } from '../modals/KycStatusHistoryModal';

import { useAppDispatch } from '@/hooks/redux-helpers';

import { openModal } from '@/store/actions/core.actions';

import { KycReview } from '@/features/kyc/store/models/kyc.model';

import { useKycInfos } from '@/features/kyc/hooks/useKycInfos';

import { KycStatus } from '@/features/kyc/components/kyc-infos/KycStatus';

export const KycGlobalStatus = () => {
  const { t } = useTranslation();
  const { user, pageTitle, hasAdditionalVigilanceMeasureBlock } = useKycInfos();

  const dispatch = useAppDispatch();

  const isKycHistoryActive =
    KycReview[user.kycReview] !== 'None' && user?.kycReviewComment !== undefined && user?.kycReviewComment !== '';

  const toggleKycHistoryModal = () =>
    dispatch(
      openModal<IKycStatusHistoryModalProps>('kycStatusHistoryModal', { user, title: pageTitle }, { fullWidth: true }),
    );

  return (
    <div className={clsx('flex', hasAdditionalVigilanceMeasureBlock ? 'flex-col gap-5' : 'gap-8')}>
      <div className="flex flex-col gap-2 items-start">
        <h6 className="typo-h6-bold text-secondary">
          {t('pages.currentProfiles.kyc.global.title', { value: pageTitle })}
        </h6>
        <Button
          icon="chevron_right"
          disabled={!isKycHistoryActive}
          iconPosition="right"
          variant="ghost"
          onClick={toggleKycHistoryModal}
        >
          {t('pages.currentProfiles.kyc.actions.seeDetails')}
        </Button>
      </div>
      <div
        className={clsx(
          'flex',
          hasAdditionalVigilanceMeasureBlock ? 'items-center gap-4' : 'items-start flex-col gap-2',
        )}
      >
        <p className="typo-body-regular-paragraph text-secondary">
          {t('pages.currentProfiles.kyc.global.labels.kycStatus')}
        </p>
        <KycStatus user={user} />
      </div>
    </div>
  );
};
